// extracted by mini-css-extract-plugin
export var highlightFade = "_2q-4";
export var highlighted = "_2q-3";
export var table = "_2q-1";
export var tableContainer = "_2q-0";
export var totalsRow = "_2q-2";